import React from 'react';
export const content = (
  <React.Fragment>
    <p>
      Puppies are synonymous with mischief. From teething to potty-training, nothing is off-limits
      in your home. Without the proper preparations and tools, the resulting chaos can have negative
      consequences for your puppy, your home, and you.
    </p>
    <p>
      That’s why it’s important to have the right supplies to keep your puppy safe—and ensure they
      are chewing on the right toys. Here are 3 quick tips for prepping your home for a new puppy.
    </p>
  </React.Fragment>
);
